// @flow
import { withRouter } from 'react-router-dom';
import React, { PureComponent } from 'react';

import SelectInput from 'components/fragments/input/SelectInput';
import TextInput from 'components/fragments/input/TextInput';
import { type RouterProps } from 'types/Router';
import { handleTagEvent } from 'utils/tagManagerUtils';

type Props = RouterProps;

type State = {
  selectedValue: string,
  search: string,
};

class JobSidebarForm extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    selectedValue: '',
    search: '',
  };

  _handleChange = (value: string, name: string) => {
    this.setState({ [name]: value });
  }

  _handleSubmit = (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const { selectedValue, search } = this.state;

    handleTagEvent(
      'barre_navigation',
      'clic_contacter_club',
      `/contact/nous-contacter?q=emploi_proposition`,
    );

    const params = `q=emploi_proposition&offre-qui=${encodeURIComponent(selectedValue)}&offre-poste=${encodeURIComponent(search)}`;
    this.props.history.push(`/contact/nous-contacter/?${params}`);
  }

  render() {
    const { selectedValue } = this.state;
    const selectOptions = [
      { label: 'Licencié', value: 'Licencié' },
      { label: 'Dirigeant', value: 'Dirigeant' },
      { label: 'Entraineur', value: 'Entraineur' },
      { label: 'Autre', value: 'Autre' },
    ];

    return (
      <div className="box box--white box--content mb-2 mb-md-3">
        <h3 className="mb-1">Soumettre une offre</h3>
        <p className="ft-secondary ft-black-secondary mb-2">
          Envoyez-nous votre demande pour la publier sur le site du comité.
        </p>
        <form>
          <div className="select mb-1">
            <SelectInput
              options={selectOptions}
              onChange={(value) => this._handleChange(value, 'selectedValue')}
              value={selectedValue}
              placeholder={'Je suis...'} />
          </div>
          <TextInput
            id="dQdgGFhgQrZk"
            onChange={(value) => this._handleChange(value, 'search')}
            placeholder="Je recherche..."
          />
          <button
            onClick={this._handleSubmit}
            className="btn btn--primary btn--full"
            type="submit">
            Faire une demande
          </button>
        </form>
      </div>
    );
  }
}

export default withRouter(JobSidebarForm);
